export const TWO_FACTOR_TIMEOUT_SECONDS = 180;
export const RESEND_CODE_COOLDOWN_MS = 30000;

export const ONE_MINUTE_BY_SECONDS = 60;

export const TWO_FACTOR_TYPE = {
  EMAIL: 'EMAIL',
  GOOGLE_OTP: 'OTP',
  NONE: 'NONE',
} as const;

export const DEFAULT_TWO_FACTOR_ERROR_OPTION = {
  title: '',
  description: '',
  isShowWindow: false,
};

export const DEFAULT_GOOGLE_OTP_WINDOW_OPTION = {
  qrUrl: '',
  secretKey: '',
  isShowWindow: false,
  isShowConfirmWindow: false,
};
